import AuthContextProvider from "./features/auth/context/authContext";
import NiceModal from "@ebay/nice-modal-react";
import ToastContextProvider, {ToastContainer} from "./layouts/toast";

function Providers({ children }) {

    return (
        <ToastContextProvider>
            <AuthContextProvider>
            <NiceModal.Provider>
                <ToastContainer/>
                    { children }
            </NiceModal.Provider>   
            </AuthContextProvider>
        </ToastContextProvider>
    )
}

export default Providers;